
const HeroDetails = () => {

  return (
    <div className="py-8">
        <div className="bg-primary-light border-primary border-l-4 border-b-4 p-6 rounded-2xl shadow-md max-w-[90%] mx-auto">
        <h1 className="text-2xl font-bold text-center text-primary-dark mb-4">
          जन शिक्षण संस्थान, बीकानेर
        </h1>

        <p className="text-center text-tertiary font-medium mb-2">
          सौजन्य: <span className="font-semibold">कौशल विकास एवं उद्यमिता मंत्रालय, भारत सरकार</span>
        </p>
        <p className="text-center text-tertiary font-medium mb-6">
          संचालन: <span className="font-semibold">बीकानेर प्रौढ़ शिक्षण समिति, बीकानेर</span>
        </p>

        <p className="text-tertiary leading-relaxed mb-3 indent-8">
          <span className="font-semibold">जन शिक्षण संस्थान, बीकानेर </span>
          भारत सरकार के कौशल विकास एवं उद्यमिता मंत्रालय के सौजन्य से <span className="font-semibold">बीकानेर प्रौढ़ शिक्षण समिति, बीकानेर </span>द्वारा संचालित किया जा रहा है. जन शिक्षण संस्थान, बीकानेर की स्थापना सन् 2000 में हुई। उल्लेखनीय है कि जन शिक्षण संस्थान स्कीम की शुरूआत राष्ट्रीय साक्षरता मिशन, स्कूल शिक्षा एवं साक्षरता विभाग, मानव संसाधन विकास मंत्रालय, भारत सरकार द्वारा <span className="font-semibold">श्रमिक विद्यापीठ </span>के नाम से सन् 1965 में वरली, मुम्बई से हुई। सन् 2000 से इसका नाम श्रमिक विद्यापीठ से <span className="font-semibold">जन शिक्षण संस्थान </span>कर दिया गया। भारत सरकार द्वारा <span className="font-semibold">जनवरी, 2018 </span>से देश के सभी <span className="font-semibold">जन शिक्षण संस्थानों </span>को मानव संसाधन विकास मंत्रालय से <span className="font-semibold">कौशल विकास एवं उद्यमिता मंत्रालय में सम्मिलित</span> कर दिया गया।
        </p>
        <p className="text-tertiary leading-relaxed mb-3 indent-8">
          <span className="font-semibold">जन शिक्षण संस्थान, बीकानेर </span>द्वारा अब तक संचालित <span className="font-semibold">विभिन्न प्रकार के रोजगार-स्वरोजगार परक पाठ्यक्रमों </span>में मार्च, 2024 तक निर्धारित <span className="font-semibold">लक्ष्य समूह के </span>48045 महिला-पुरुषों को विभिन्न कौशल प्रशिक्षणों में प्रशिक्षित किया गया है।
        </p>
      </div>


      <div className="bg-primary-light border-primary border-l-4 border-b-4 p-6 rounded-2xl shadow-md max-w-[90%] mx-auto mt-8">
        <h2 className="text-xl text-center font-bold text-primary-dark mb-4">
          -: मुख्य उद्देश्य :-
        </h2>
        <p className="text-tertiary leading-relaxed indent-8">
          जिले की शहरी कच्ची बस्तियों एवं ग्रामीण क्षेत्रों के <span className="font-semibold">निरक्षर, नवसाक्षर, अल्पशिक्षित, स्कूली ड्रॉप-आउट, सामाजिक आर्थिक दृष्टि से पिछड़े तथा वंचित वर्ग के बेरोजगार महिला-पुरुषों </span>को स्थानीय बाजार की माँग के अनुसार <span className="font-semibold">व्यावसायिक कौशल प्रशिक्षणों में दक्ष कर </span>उनको सामाजिक एवं आर्थिक रूप से स्वावलंबी बनाना और <span className="font-semibold">जीवन कौशल शिक्षा </span>के माध्यम से व्यक्तित्व विकास, सामाजिक विकास एवं राष्ट्रीय सरोकार की कार्य-गतिविधियों का नियमित संचालन करना।
        </p>
      </div>

      <div className="bg-primary-light border-primary border-l-4 border-b-4 p-6 rounded-2xl shadow-md max-w-[90%] mx-auto mt-8 text-center">
        <h2 className="text-xl font-bold text-primary-dark mb-4">
          -: लक्ष्य समूह :-
        </h2>
        <p className="text-tertiary font-semibold leading-relaxed mb-4">
          बीकानेर जिले के निरक्षर, नवसाक्षर, अल्पशिक्षित, स्कूली ड्रॉप-आउट तथा सामाजिक एवं
          आर्थिक रूप से पिछड़े एवं वंचित वर्ग के 15-45 आयुवर्ग के महिला-पुरूष।
        </p>

        <h2 className="text-xl font-bold text-primary-dark mb-4">
          -: निःशुल्क प्रशिक्षण :-
        </h2>
        <p className="text-tertiary font-semibold leading-relaxed">
          संस्थान द्वारा अनुसूचित जाति एवं अनुसूचित जनजाति वर्ग के (SC/ST), बीपीएल (BPL) एवं
          दिव्यांग श्रेणी के व्यक्तियों को निःशुल्क प्रशिक्षण दिया जाता है।
        </p>
      </div>
    </div>
  );
};

export default HeroDetails;
